export default {
  albumData:
    {
      "id": "ad2365fe-88c2-4ff3-94a1-75d4db2c2b96",
      "brand": {
        "logo": {
          "name": "60cca8_4dc954ac18d84e45b3b30cf95735edb5~mv2.jpg",
          "title": "matt-lee-18767.jpg",
          "mediaUrl": "s",
          "photoMetadata": {
            "width": 3888,
            "height": 2592
          }
        },
        "name": "Exposure",
        "type": "NAME"
      },
      "cover": {
        "id": "c895035c-021d-4ead-9948-b1e15273e09e",
        "name": "60cca8_d74e96387164473280c7dcaa62d7eab1~mv2.jpg",
        "title": "casey-horner-_4XcZQ-2G5Q-unsplash",
        "created": "2020-09-08T13:53:31.364Z",
        "visible": true,
        "dataType": "Photo",
        "isSecure": true,
        "mediaUrl": "https://static.wixstatic.com/media/60cca8_d74e96387164473280c7dcaa62d7eab1~mv2.jpg/v1/fill/w_4016,h_6016,al_c,q_90/60cca8_d74e96387164473280c7dcaa62d7eab1~mv2.jpg",
        "modified": "2020-09-08T13:53:31.364Z",
        "thumbnail": "data:image/png;base64,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",
        "imageToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ1cm46YXBwOjZiZTRmNGFmMjAzOTQwOTVhZDY5Y2NjMzk4ODkyYzhkIiwib2JqIjpbW3sicGF0aCI6Ii9tZWRpYS82MGNjYThfZDc0ZTk2Mzg3MTY0NDczMjgwYzdkY2FhNjJkN2VhYjF-bXYyLmpwZyJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sImlzcyI6InVybjphcHA6NmJlNGY0YWYyMDM5NDA5NWFkNjljY2MzOTg4OTJjOGQiLCJpYXQiOjE1OTk4Mjk3MTYsImp0aSI6IjVlNGJjNWRhYmNhNiIsImV4cCI6MTU5OTgzMDMyNiwid21rIjp7InBhdGgiOiIvbWVkaWEvOGJiNDM4XzM5YTc4YjQ2ZDRmZTQ3MDY5ZGE2M2RhOTM0OGI0ZWU1fm12Mi5wbmciLCJvcGFjaXR5IjoxLCJwcm9wb3J0aW9ucyI6MC4xLCJncmF2aXR5Ijoibm9ydGgtd2VzdCJ9fQ.ziUotJMOvaWN9jSd-fWnhcH282EBGz2db7ErLboiJBs",
        "mediaOwner": "Wix",
        "orderIndex": 1599573209657,
        "photoMetadata": {
          "width": 4016,
          "height": 6016,
          "focalPoint": {
            "x": 0.5,
            "y": 0.5
          }
        }
      },
      "colors": {
        "pageTexts": "#121212",
        "coverTexts": "#FFFFFF",
        "galleriesTexts": "#FFFFFF",
        "pageBackground": "#FFFFFF",
        "coverBackground": "#000000",
        "galleriesOverlay": "#000000"
      },
      "folder": {
        "id": "7f348936e8664e98b4cfdd09054a6203",
        "name": "Tals album"
      },
      "layout": "collage",
      "siteId": "b68f27c6-47da-447c-835e-b32d31061e78",
      "userId": "60cca876-a865-457d-b852-96265a773c22",
      "version": 2,
      "welcome": "View Photos",
      "allowSEO": true,
      "siteName": "tals-album",
      "template": {
        "name": "classic2",
        "title": "Albums_Wizard_StylePage_Classic",
        "colors": {
          "pageTexts": "#121212",
          "coverTexts": "#FFFFFF",
          "galleriesTexts": "#FFFFFF",
          "pageBackground": "#FFFFFF",
          "coverBackground": "#000000",
          "galleriesOverlay": "#000000"
        },
        "siteId": "07994d96-7ad9-48d2-9a28-f6ffd8b51e5d",
        "version": 3,
        "metasiteId": "93f87473-1865-4405-a7da-de2b6c6053bd",
        "selectedFontSet": 10,
        "coverIsBackground": true
      },
      "albumDate": "01/09/2020",
      "albumName": "Demo Album",
      "albumPass": "",
      "homeSetId": "9c4b2cdd-9a60-4aa8-950c-44f953b53136",
      "publicUrl": "https://dorr42.wixsite.com/tals-album",
      "watermark": {
        "size": 10,
        "opacity": 1,
        "imageUrl": "8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png",
        "position": 1,
        "imageRatio": 1
      },
      "accessType": "PUBLIC",
      "metaSiteId": "69603c14-18b3-4543-9f7c-0d0c6293a321",
      "modifiedAt": 1599829649357,
      "dateCreated": 1599573208762,
      "displayDate": true,
      "pricelistId": "da5cb7c0-59cf-45c9-90c0-4862e2d51622",
      "setsSummary": {
        "3bffad92-1ed6-4468-81e3-8be61b84a549": {
          "id": "3bffad92-1ed6-4468-81e3-8be61b84a549",
          "name": "Gallery",
          "items": [],
          "orderIndex": 1599573209104
        },
        "d23a49cd-aafa-4481-9e4b-49b6e071be68": {
          "id": "d23a49cd-aafa-4481-9e4b-49b6e071be68",
          "name": "Gallery 3",
          "items": [],
          "orderIndex": 1599573528753
        },
        "f1e97c3b-9d42-47a9-8c3a-6411c295eaa1": {
          "id": "f1e97c3b-9d42-47a9-8c3a-6411c295eaa1",
          "name": "Gallery 2",
          "items": [],
          "orderIndex": 1599573255302
        }
      },
      "styleParams": {
        "usm_a": 0,
        "usm_r": 0,
        "usm_t": 0,
        "isGrid": true,
        "oneRow": false,
        "cubeType": "fill",
        "isSlider": false,
        "viewMode": "preview",
        "boxShadow": 0,
        "cubeRatio": 1,
        "gridStyle": 1,
        "groupSize": 1,
        "isColumns": false,
        "isMasonry": false,
        "itemClick": "expand",
        "smartCrop": false,
        "usmToggle": false,
        "videoLoop": true,
        "videoPlay": "hover",
        "allowHover": true,
        "allowTitle": false,
        "cubeImages": true,
        "fullscreen": true,
        "groupTypes": "1",
        "isVertical": true,
        "loveButton": true,
        "showArrows": false,
        "videoSound": false,
        "videoSpeed": "1",
        "allowSocial": false,
        "arrowsColor": {
          "value": "#FFFFFF"
        },
        "gallerySize": 70,
        "galleryType": "Columns",
        "imageMargin": 30,
        "imageResize": 0,
        "isSlideshow": false,
        "itemOpacity": {
          "value": "rgba(41, 41, 41, 0.6)"
        },
        "loveCounter": true,
        "minItemSize": 50,
        "sharpParams": {
          "usm": {},
          "quality": 90
        },
        "borderRadius": 0,
        "cropOnlyFill": false,
        "enableScroll": true,
        "fixedColumns": 0,
        "imageQuality": 90,
        "overlayColor": {
          "value": "#000000"
        },
        "previewHover": false,
        "useWatermark": true,
        "allowDownload": false,
        "galleryLayout": 2,
        "hasThumbnails": false,
        "imageInfoType": "NO_BACKGROUND",
        "itemFontColor": {
          "value": "#FFFFFF"
        },
        "itemIconColor": {
          "value": "#FFFFFF"
        },
        "slideshowLoop": false,
        "textBoxHeight": 200,
        "thumbnailSize": 120,
        "watermarkDock": {
          "top": "auto",
          "left": "auto",
          "right": 0,
          "bottom": 0,
          "transform": "translate3d(0,0,0)"
        },
        "watermarkSize": 40,
        "arrowsPosition": 0,
        "collageDensity": 0.4,
        "floatingImages": 0,
        "fullscreenLoop": false,
        "gotStyleParams": true,
        "groupsPerStrip": 0,
        "itemShadowBlur": 20,
        "itemShadowSize": 10,
        "loadMoreAmount": "all",
        "mobilePanorama": false,
        "overlayOpacity": 0.5,
        "placeGroupsLtr": true,
        "textImageSpace": 10,
        "titlePlacement": "SHOW_ON_HOVER",
        "allowLinkExpand": false,
        "alwaysShowHover": false,
        "chooseBestGroup": true,
        "expandAnimation": "NO_EFFECT",
        "isAutoSlideshow": false,
        "itemBorderColor": {
          "value": "#292929"
        },
        "itemBorderWidth": 0,
        "magicLayoutSeed": 1,
        "scrollAnimation": "FADE_IN",
        "scrollDirection": 0,
        "useCustomButton": false,
        "allowDescription": false,
        "allowTitleExpand": true,
        "bottomInfoHeight": 0,
        "customButtonText": "Buy Now",
        "galleryTextAlign": "center",
        "imageLoadingMode": "BLUR",
        "itemBorderRadius": 0,
        "itemEnableShadow": false,
        "overlayAnimation": "FADE_IN",
        "textBoxFillColor": {
          "value": "#FFFFFF"
        },
        "watermarkOpacity": 40,
        "hoveringBehaviour": "APPEARS",
        "imageLoadingColor": {
          "value": "#CCCCCC"
        },
        "rotatingCubeRatio": "",
        "slideshowInfoSize": 200,
        "thumbnailSpacings": 4,
        "expandInfoPosition": 0,
        "galleryAlignExpand": "left",
        "loadMoreButtonText": "",
        "rotatingGroupTypes": "",
        "textBoxBorderColor": {
          "value": "#292929"
        },
        "textBoxBorderWidth": 0,
        "addToCartButtonText": "",
        "imageHoverAnimation": "NO_EFFECT",
        "itemShadowDirection": 135,
        "textBoxBorderRadius": 0,
        "addToCartBorderWidth": 1,
        "enableInfiniteScroll": true,
        "galleryVerticalAlign": "center",
        "numberOfImagesPerCol": 1,
        "numberOfImagesPerRow": 3,
        "textsVerticalPadding": 0,
        "allowFullscreenExpand": true,
        "allowSlideshowCounter": false,
        "autoSlideshowInterval": 4,
        "customButtonFontColor": {
          "value": "#FFFFFF"
        },
        "defaultShowInfoExpand": 1,
        "selectedGalleryLayout": "grid",
        "allowDescriptionExpand": true,
        "galleryHorizontalAlign": "center",
        "itemFontColorSlideshow": {
          "value": "#292929"
        },
        "itemIconColorSlideshow": {
          "value": "#292929"
        },
        "oneColorAnimationColor": {
          "value": "#FFFFFF"
        },
        "customButtonBorderWidth": 1,
        "gallerySliderImageRatio": 1.7777777777777777,
        "customButtonBorderRadius": 0,
        "galleryImageRatioFromWix": 1,
        "itemDescriptionFontColor": {
          "value": "#FFFFFF"
        },
        "itemShadowOpacityAndColor": {
          "value": "rgba(41, 41, 41, 0.2)"
        },
        "loadMoreButtonBorderColor": {
          "value": "#292929"
        },
        "loadMoreButtonBorderWidth": 1,
        "calculateTextBoxHeightMode": "AUTOMATIC",
        "galleryThumbnailsAlignment": "bottom",
        "loadMoreButtonBorderRadius": 0,
        "playButtonForAutoSlideShow": false,
        "customButtonFontColorForHover": {
          "value": "#292929"
        },
        "useRefactoredGalleryContainer": false,
        "itemDescriptionFontColorSlideshow": {
          "value": "#292929"
        }
      },
      "allowDisplay": true,
      "defaultSetId": "3bffad92-1ed6-4468-81e3-8be61b84a549",
      "displayBrand": true,
      "isStoreAlbum": false,
      "userFontSets": [],
      "lastWatermark": {
        "size": 66,
        "opacity": 65,
        "imageUrl": "60cca8_b2fa9c746b874b2581f9bde89d15f77b~mv2.png",
        "position": 3,
        "imageRatio": 1
      },
      "loginLanguage": "en",
      "motherSiteUrl": "https://dorr42.wixsite.com/mysite-20",
      "ulrModifiedAt": 1599573314773,
      "selectedFontSet": 10,
      "imageAddDirection": "GALLERY_END",
      "originalPublicUrl": "https://dorr42.wixsite.com/tals-album",
      "defaultNewItemName": "FILE_NAME",
      "isWatermarkEnabled": false,
      "motherSiteMetaSiteId": "81f8f788-cd49-45b4-8806-b5e646cc72f5",
      "shouldShowPhotoRightsNotification": false,
      "coverUrl":"https://static.wixstatic.com/media/60cca8_5a335dbfc4104d47964635f7f684fd9a~mv2.jpg/v1/fill/w_805,h_1331,al_c,q_85,wm_8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png-1-1-10/60cca8_5a335dbfc4104d47964635f7f684fd9a~mv2.jpg",
      "freeArtStore": true,
      "transparent": "https://static.wixstatic.com/media/60cca8_c6fad025c40a4acb840f458b3b6f5f5b~mv2.png/v1/fit/w_297,h_206/60cca8_c6fad025c40a4acb840f458b3b6f5f5b~mv2.png"

  },
  sets: [
    {
      "id": "364e02b5-2729-4629-971c-13b4c2def85d",
      "name": "Gallery",
      "totalItemsCount": 28,
      "items": [
        {
          "type": "image",
          "slug": "16fca6db-91a1-4424-986d-23e2d6e21025",
          "title": "bailey-zindel-NRQV-hBF10M-unsplash",
          "src": "wix:image://v1/60cca8_e7df637b43594bd3b549a320f4038036~mv2.jpg/bailey-zindel-nrqv-hbf10m-unsplash.jpg#originWidth=7360&originHeight=4912",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "e13eed45-bde9-4fa1-86ef-b27ac236ff23",
          "title": "casey-horner-_4XcZQ-2G5Q-unsplash",
          "src": "wix:image://v1/60cca8_d2f1168c42064d65af3fa58f9632293f~mv2.jpg/casey-horner-_4xczq-2g5q-unsplash.jpg#originWidth=4016&originHeight=6016",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "311ee41b-891e-4592-9cfc-69cf13e09892",
          "title": "claudio-testa--SO3JtE3gZo-unsplash",
          "src": "wix:image://v1/60cca8_4af1a2b5e99b417584166be1511ab3f0~mv2.jpg/claudio-testa-so3jte3gzo-unsplash.jpg#originWidth=5184&originHeight=3240",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "b41cb979-25e1-4b2f-aaaf-8b2b3f558b25",
          "title": "daniela-cuevas-t7YycgAoVSw-unsplash",
          "src": "wix:image://v1/60cca8_d3aa22233d034532bee83fb244bc7ae8~mv2.jpg/daniela-cuevas-t7yycgaovsw-unsplash.jpg#originWidth=5760&originHeight=3840",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "428ebddb-8844-4c1f-895d-4719f5fb2da4",
          "title": "jeff-king-bJHWJeiHfHc-unsplash",
          "src": "wix:image://v1/60cca8_c93c3b05e81b4354aa38719494a9da49~mv2.jpg/jeff-king-bjhwjeihfhc-unsplash.jpg#originWidth=3827&originHeight=2546",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "7165c4a6-0468-4281-855c-3ffcd97977fc",
          "title": "johannes-plenio-RwHv7LgeC7s-unsplash",
          "src": "wix:image://v1/60cca8_15009a8e34eb44a2bb36a42b84cb2428~mv2.jpg/johannes-plenio-rwhv7lgec7s-unsplash.jpg#originWidth=4368&originHeight=2912",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "2cc2f168-c2ea-4299-964e-ee948d8553a6",
          "title": "jonatan-pie-P2vi01BW8vE-unsplash",
          "src": "wix:image://v1/60cca8_72bf7a495eec46f78826a7dc274d6896~mv2.jpg/jonatan-pie-p2vi01bw8ve-unsplash.jpg#originWidth=4912&originHeight=7360",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "51ca5622-9360-4b62-8392-fd1daa351763",
          "title": "ken-cheung-KonWFWUaAuk-unsplash",
          "src": "wix:image://v1/60cca8_5e8ae05b5a33420f9bdfdce86106bff5~mv2.jpg/ken-cheung-konwfwuaauk-unsplash.jpg#originWidth=5128&originHeight=3419",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "fee0ed83-88de-4cb7-9fa9-9faff7e50547",
          "title": "luca-bravo-zAjdgNXsMeg-unsplash",
          "src": "wix:image://v1/60cca8_5b17c111bf714b85ab026e30b43487cd~mv2.jpg/luca-bravo-zajdgnxsmeg-unsplash.jpg#originWidth=4513&originHeight=3009",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "80768af9-6690-4234-b1d9-f876eb408a64",
          "title": "ryan-schroeder-Gg7uKdHFb_c-unsplash",
          "src": "wix:image://v1/60cca8_d5069a0ecff44913b00bec19c0eb5679~mv2.jpg/ryan-schroeder-gg7ukdhfb_c-unsplash.jpg#originWidth=4442&originHeight=2961",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "79fd4b6d-255c-470e-8e86-392704351e94",
          "title": "simon-berger-twukN12EN7c-unsplash",
          "src": "wix:image://v1/60cca8_bd8e3c0d905045d9ac078d00069092f7~mv2.jpg/simon-berger-twukn12en7c-unsplash.jpg#originWidth=4608&originHeight=2963",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "b5578b72-2c26-4066-ac86-9377a6ec3fd7",
          "title": "pietro-de-grandi-T7K4aEPoGGk-unsplash",
          "src": "wix:image://v1/60cca8_7d6f31e0a5214e93af8cba42e3dd66fb~mv2.jpg/pietro-de-grandi-t7k4aepoggk-unsplash.jpg#originWidth=5979&originHeight=3986",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "73c1e365-24bd-4926-8bcb-721690fe1d33",
          "title": "mark-harpur-K2s_YE031CA-unsplash",
          "src": "wix:image://v1/60cca8_f3c22430c33545a8a54dc93897bdcbd1~mv2.jpg/mark-harpur-k2s_ye031ca-unsplash.jpg#originWidth=5112&originHeight=3408",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "a70a9f29-2d2e-4c2e-993a-524a7f78f9e4",
          "title": "ales-krivec-4miBe6zg5r0-unsplash",
          "src": "wix:image://v1/60cca8_82995bc4608d474881d64865f826ee85~mv2.jpg/ales-krivec-4mibe6zg5r0-unsplash.jpg#originWidth=7360&originHeight=4100",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "ba6a2f1f-ec1f-4201-810a-147653ed922c",
          "title": "bailey-zindel-NRQV-hBF10M-unsplash",
          "src": "wix:image://v1/60cca8_62c3a35807464e34986ca83fcb9d5cb1~mv2.jpg/bailey-zindel-nrqv-hbf10m-unsplash.jpg#originWidth=7360&originHeight=4912",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "69ae315f-e179-4eb7-a71b-83b7b92383bf",
          "title": "casey-horner-_4XcZQ-2G5Q-unsplash",
          "src": "wix:image://v1/60cca8_38c2932f68c04052a39eb0a762912e12~mv2.jpg/casey-horner-_4xczq-2g5q-unsplash.jpg#originWidth=4016&originHeight=6016",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "0acc8bd5-c76e-4843-a41d-6dfab6fda825",
          "title": "claudio-testa--SO3JtE3gZo-unsplash",
          "src": "wix:image://v1/60cca8_50ccce9b00c04db884e4dcacca9a3cd5~mv2.jpg/claudio-testa-so3jte3gzo-unsplash.jpg#originWidth=5184&originHeight=3240",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "69358046-9e48-401b-af43-27cac8b83a3b",
          "title": "daniela-cuevas-t7YycgAoVSw-unsplash",
          "src": "wix:image://v1/60cca8_1b0d610e6b4748198c7c7e2ed6a6773e~mv2.jpg/daniela-cuevas-t7yycgaovsw-unsplash.jpg#originWidth=5760&originHeight=3840",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "b5512711-2b7e-41d3-bca6-3a03bdedb845",
          "title": "jeff-king-bJHWJeiHfHc-unsplash",
          "src": "wix:image://v1/60cca8_a0c1d414478547eaa14038ec758f9213~mv2.jpg/jeff-king-bjhwjeihfhc-unsplash.jpg#originWidth=3827&originHeight=2546",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "7060e00c-a471-49a5-9588-bbcf000d127b",
          "title": "johannes-plenio-RwHv7LgeC7s-unsplash",
          "src": "wix:image://v1/60cca8_4f4a2ebb79e4472c9a45dd9dc0a152ce~mv2.jpg/johannes-plenio-rwhv7lgec7s-unsplash.jpg#originWidth=4368&originHeight=2912",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "888818e3-3860-4d05-84ec-b0cc5b380ca5",
          "title": "jonatan-pie-P2vi01BW8vE-unsplash",
          "src": "wix:image://v1/60cca8_eb0aac5a89f04accbdbe96cf7f6f5ee9~mv2.jpg/jonatan-pie-p2vi01bw8ve-unsplash.jpg#originWidth=4912&originHeight=7360",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "92f20ffe-e2f3-4993-b4fb-896b4bc0d986",
          "title": "ken-cheung-KonWFWUaAuk-unsplash",
          "src": "wix:image://v1/60cca8_c5f4f93ec30c4312a736cca5336459a3~mv2.jpg/ken-cheung-konwfwuaauk-unsplash.jpg#originWidth=5128&originHeight=3419",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "e3222713-24ba-46bb-81f6-5669b0d2d597",
          "title": "luca-bravo-zAjdgNXsMeg-unsplash",
          "src": "wix:image://v1/60cca8_df22d4ea6b3443d9beecfcbc301e5d8a~mv2.jpg/luca-bravo-zajdgnxsmeg-unsplash.jpg#originWidth=4513&originHeight=3009",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "ede3c012-6cea-4fbe-8c61-bef8d8dc76a3",
          "title": "mark-harpur-K2s_YE031CA-unsplash",
          "src": "wix:image://v1/60cca8_71d7579d1a514e049ca461a78a9f63da~mv2.jpg/mark-harpur-k2s_ye031ca-unsplash.jpg#originWidth=5112&originHeight=3408",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "f8a8d76d-d05e-4649-b4ca-83b54f413f86",
          "title": "pietro-de-grandi-T7K4aEPoGGk-unsplash",
          "src": "wix:image://v1/60cca8_1c34725b6b914667bf7fd09dcd7f17cf~mv2.jpg/pietro-de-grandi-t7k4aepoggk-unsplash.jpg#originWidth=5979&originHeight=3986",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "cf7933a3-aba0-4d70-841e-0e2a47e12b07",
          "title": "ryan-schroeder-Gg7uKdHFb_c-unsplash",
          "src": "wix:image://v1/60cca8_2f9072acd0ad497ab2d7223fc72e337e~mv2.jpg/ryan-schroeder-gg7ukdhfb_c-unsplash.jpg#originWidth=4442&originHeight=2961",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "7666f160-5fe7-4b8a-8c18-a67885628546",
          "title": "simon-berger-twukN12EN7c-unsplash",
          "src": "wix:image://v1/60cca8_927cb31990ec4e6192acc9235a4dc7d5~mv2.jpg/simon-berger-twukn12en7c-unsplash.jpg#originWidth=4608&originHeight=2963",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        }
      ],
      "created": "2020-09-10T10:23:21Z",
      "orderIndex": 1599733401056,
      "nextGalleryName": "Gallery 2",
      "nextGalleryId": "dcfed5e6-a3a1-4ea2-963c-f135d6458dd1",
      "zipUrl": "https://www.wix.com/_api/albums-node-server/downloadZip?metaSiteId=81f8f788-cd49-45b4-8806-b5e646cc72f5&instanceId=ad2365fe-88c2-4ff3-94a1-75d4db2c2b96&state=PUBLISHED&setId=364e02b5-2729-4629-971c-13b4c2def85d"
    },
    {
      "id": "dcfed5e6-a3a1-4ea2-963c-f135d6458dd1",
      "name": "Gallery 2",
      "totalItemsCount": 14,
      "items": [
        {
          "type": "image",
          "slug": "e92d6b5b-98db-4444-8741-a09ac209754d",
          "title": "ales-krivec-4miBe6zg5r0-unsplash",
          "src": "wix:image://v1/60cca8_2133cb393a364c1eb09217610a8029af~mv2.jpg/ales-krivec-4mibe6zg5r0-unsplash.jpg#originWidth=7360&originHeight=4100",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "383c7d0c-fcc0-45e4-b204-a6302f2f1bde",
          "title": "bailey-zindel-NRQV-hBF10M-unsplash",
          "src": "wix:image://v1/60cca8_d1bf7b11a1594b6fa756a6ce89ca3254~mv2.jpg/bailey-zindel-nrqv-hbf10m-unsplash.jpg#originWidth=7360&originHeight=4912",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "dd7fc027-38e3-40db-b594-a3190a50f1f7",
          "title": "casey-horner-_4XcZQ-2G5Q-unsplash",
          "src": "wix:image://v1/60cca8_ca7051417f54427db97b5ae0a0fc27f6~mv2.jpg/casey-horner-_4xczq-2g5q-unsplash.jpg#originWidth=4016&originHeight=6016",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "08594863-85c0-4cca-9ab5-64feb3342fe7",
          "title": "claudio-testa--SO3JtE3gZo-unsplash",
          "src": "wix:image://v1/60cca8_5a6199180d6045d883e6aa163c13b7de~mv2.jpg/claudio-testa-so3jte3gzo-unsplash.jpg#originWidth=5184&originHeight=3240",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "e3dddcc4-3660-4f09-840c-f5ab27eef899",
          "title": "daniela-cuevas-t7YycgAoVSw-unsplash",
          "src": "wix:image://v1/60cca8_40de3f58e5364517b2e31ed8033c3a47~mv2.jpg/daniela-cuevas-t7yycgaovsw-unsplash.jpg#originWidth=5760&originHeight=3840",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "9197fbd8-8418-48b5-944b-b58ab1b741a8",
          "title": "jeff-king-bJHWJeiHfHc-unsplash",
          "src": "wix:image://v1/60cca8_9c2eb5beaef64759b77eefe2148683c6~mv2.jpg/jeff-king-bjhwjeihfhc-unsplash.jpg#originWidth=3827&originHeight=2546",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "c974c37b-3fbc-4ff6-8024-23798fc1ebc1",
          "title": "johannes-plenio-RwHv7LgeC7s-unsplash",
          "src": "wix:image://v1/60cca8_318a91b40ed949038ceb1a4b3a7fa5c1~mv2.jpg/johannes-plenio-rwhv7lgec7s-unsplash.jpg#originWidth=4368&originHeight=2912",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "68b6616e-f5ca-4716-b665-cf5add7d7cda",
          "title": "jonatan-pie-P2vi01BW8vE-unsplash",
          "src": "wix:image://v1/60cca8_54754c3e44d54b4085d909c60e49cc67~mv2.jpg/jonatan-pie-p2vi01bw8ve-unsplash.jpg#originWidth=4912&originHeight=7360",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "6442dee5-46e3-4728-807a-49b0e93dfa46",
          "title": "ken-cheung-KonWFWUaAuk-unsplash",
          "src": "wix:image://v1/60cca8_243d69300a454ff49eb374d9a1d0e91c~mv2.jpg/ken-cheung-konwfwuaauk-unsplash.jpg#originWidth=5128&originHeight=3419",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "d06ae358-4b80-4082-962a-b7bd22d66dc9",
          "title": "luca-bravo-zAjdgNXsMeg-unsplash",
          "src": "wix:image://v1/60cca8_822df889632a44dba610137154b506a3~mv2.jpg/luca-bravo-zajdgnxsmeg-unsplash.jpg#originWidth=4513&originHeight=3009",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "4a9c9fc1-9015-4452-b157-705844d83c03",
          "title": "mark-harpur-K2s_YE031CA-unsplash",
          "src": "wix:image://v1/60cca8_74e96b941429470a85add60826a16707~mv2.jpg/mark-harpur-k2s_ye031ca-unsplash.jpg#originWidth=5112&originHeight=3408",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "abb3236e-c147-4b3d-9de1-f788b01d6fb6",
          "title": "pietro-de-grandi-T7K4aEPoGGk-unsplash",
          "src": "wix:image://v1/60cca8_7c9936a9163c4ba580e012a0c73b102a~mv2.jpg/pietro-de-grandi-t7k4aepoggk-unsplash.jpg#originWidth=5979&originHeight=3986",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "7d4aa2dc-fc4a-4965-8bcf-4b6be73b12c1",
          "title": "ryan-schroeder-Gg7uKdHFb_c-unsplash",
          "src": "wix:image://v1/60cca8_b885835c2e264810b53268dc97051bd9~mv2.jpg/ryan-schroeder-gg7ukdhfb_c-unsplash.jpg#originWidth=4442&originHeight=2961",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        },
        {
          "type": "image",
          "slug": "cf30a5e5-aeab-4a94-998a-d2128975ad60",
          "title": "simon-berger-twukN12EN7c-unsplash",
          "src": "wix:image://v1/60cca8_96dd6e6070574f43a9fa906e3d3e0414~mv2.jpg/simon-berger-twukn12en7c-unsplash.jpg#originWidth=4608&originHeight=2963",
          "settings": {
            "focalPoint": [
              0.5,
              0.5
            ]
          },
          "defaultSetId": "364e02b5-2729-4629-971c-13b4c2def85d"
        }
      ],
      "created": "2020-09-10T10:24:28Z",
      "orderIndex": 1599733467643,
      "zipUrl": "https://www.wix.com/_api/albums-node-server/downloadZip?metaSiteId=81f8f788-cd49-45b4-8806-b5e646cc72f5&instanceId=ad2365fe-88c2-4ff3-94a1-75d4db2c2b96&state=PUBLISHED&setId=dcfed5e6-a3a1-4ea2-963c-f135d6458dd1"
    }
  ],
}
